export default __webpack_public_path__ + "static/media/663.a3ebdce4.png";